import _ from 'lodash'
export const differenceLeft = (left, right, acc={}) => {
  for (const key in left) {
    if (_.isPlainObject(left[key]) && !_.isNil(right)) {
      if (_.isArray(left[key])) {
        acc[key] = _.cloneDeep(left[key])
        continue  // omiting array elements produces confusing output
      }
      acc[key] = _.isArray(left[key]) ? [] : {}
      differenceLeft(left[key], right[key], acc[key])
      if (_.keys(acc[key]).length == 0 && _.size(left[key]) > 0) delete acc[key]
      continue
    }
    if (_.isNil(right) || left[key] !== right[key]) acc[key] = left[key]
  }
  return acc
}
